import apiService from '../../Services/APIService';
import { checkAPIResponse } from '../../Utils/APIResponseUtils';

export const getAgencyStatsAPI = async (filters = {}) => {
  try {
    const result = await apiService.getData(10, 'getUsage', filters);

    checkAPIResponse(result);

	const updatePackage = JSON.parse(result.updatePackage);
    const data = updatePackage.Table1;
	
    return data;

  } catch (error) {
    console.error('getAgencyStats API error:', error);
    throw error;
  }
};

export const getBiggestCustomersAPI = async (payload) => {
 
  const result = await apiService.getData(1, "getConnAnalysis", payload);
  checkAPIResponse(result)
  return result
}

export const getSegmentAnalyticsAPI = async ({ threadTypeID, rptType = "SEGMENT", prdType, prdQty, year, month }) => {
  const payload = [{
    threadTypeID,
    rptType,
    prdType,
    prdQty,
    year,
    month
  }];
  const result = await apiService.getData(2, "getAnalysis", payload);
  checkAPIResponse(result)
  return result
}

export const sendWspTemplateAPI = async (payload) => {
  try {
    const result = await apiService.sendChange(16, "sendWspTemplate", [payload]);
    return result;
  } catch (error) {
    console.error("sendWspTemplate API error:", error);
    throw error;
  }
};